module.exports = __webpack_public_path__ + "static/media/provider-house.633c01d2.svg";